<template>
    <div class="24h-motor-view">
    <!-- home page view , each <section> must be a layout component -->
    <!-- <landing-intro v-bind="LandingIntroData" /> -->
    <covid-banner  />

    <landing-intro-v2 v-bind:LandingIntroData="LandingIntroData" />
    <executive-summary v-bind="ExecutiveSummaryData" />
     <!-- video -->
     <!-- <video /> -->

     <!-- what we offer -->
     <!-- <24hmotor-what-we-offer /> -->

    <contact-us v-bind="ContactUsData" />
    <!-- <FooterLayout /> -->
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>